import { render, staticRenderFns } from "./ViewMemberSwipes.vue?vue&type=template&id=4e4db2aa"
import script from "./ViewMemberSwipes.vue?vue&type=script&lang=js"
export * from "./ViewMemberSwipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports